import * as React from 'react';

function BelowProficiencyTarget(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={62} height={12} viewBox="0 0 62 12" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M31.5 1.129L35.335 3.5H59a2 2 0 012 2v1a2 2 0 01-2 2H35.24l-3.83 2.371a.866.866 0 01-.91 0L26.667 8.5H3a2 2 0 01-2-2v-1a2 2 0 012-2h23.757l3.834-2.371a.866.866 0 01.91 0z"
          stroke="#BDBDBD"
        />
        <path d="M3 5h24v2H3a1 1 0 110-2z" fill="#FFC500" />
      </g>
    </svg>
  );
}

export default BelowProficiencyTarget;
